// extracted by mini-css-extract-plugin
var _1 = "SubMenuAccordionButton-moduleSubMenuAccordionButton__px_bW";
var _2 = "SubMenuAccordionButton-moduletext__qeESv";
var _3 = "SubMenuAccordionButton-modulewithSelectedItem__QNkBb";
export { _1 as "SubMenuAccordionButton", _2 as "text", _3 as "withSelectedItem" }
